<template>
    <main class="">
      <div class="w-full bg-brand-secondary text-center py-2" v-if="announcement">
        <h2 class="container mx-auto text-white" v-html="announcement">
</h2>
      </div>
    </main>
</template>

<script lang='ts' setup>
import { defineProps } from 'vue';

defineProps<{
  announcement: string
}>();

</script>
